var shouldUseFlex = function shouldUseFlex(props) {
  return props.flex || Object.keys(props).map(function (item) {
    return !(item === "children" || item === "spaceAfter" || item === "spacing" || item === "dataTest");
  }).indexOf(true) !== -1;
};

export default shouldUseFlex;